import * as React from "react";
import { Col, FormGroup, Row } from "react-bootstrap";
import Feedback from "react-bootstrap/Feedback";

import { adCopyStrategyTargetGroupLabels } from "../../../../../../../../label/ad-copy/activity";
import type { ErrorObject } from "../../../../../../../../react-components/lu-component/src/index";
import type { SurveyChoice } from "../../../../../../../../server/models/shared";
import type { TrueAdCopyStrategyGroup } from "../../../../../../types/ad-copy/activity";
import { AccordionForm } from "../../../../../parts/accodion-form";
import { AdCopyCheckboxes } from "../../../../../parts/ad-copy/checkboxes";
import { AdCopyRadios } from "../../../../../parts/ad-copy/radios";
import { adCopyOrAndOptions } from "./or-and-options";
import { highlight非 } from "./utils";

const key = "nonPurchaseCategoryConfig";

type Key = typeof key;

type Props = {
	errors: ErrorObject | undefined;
	onChange: (name: Key, value: TrueAdCopyStrategyGroup[Key]) => void;
	strategyGroup: TrueAdCopyStrategyGroup;
	surveyChoiceOptions: SurveyChoice[];
};

export const AdCopyNonPurchaseCategoryConfigForm = React.memo((props: Props) => {
	const { errors, onChange, strategyGroup, surveyChoiceOptions } = props;

	const nonPurchaseCategoryConfigError = errors?.[key];

	const categoryOrAndError = React.useMemo(() => {
		if (nonPurchaseCategoryConfigError == null || typeof nonPurchaseCategoryConfigError === "string") {
			return;
		}

		const error = nonPurchaseCategoryConfigError["categoryOrAnd"];

		if (typeof error === "string") {
			return error;
		}
	}, [nonPurchaseCategoryConfigError]);

	const nonPurchaseCategoryConfig = strategyGroup[key];

	return (
		<Row>
			<FormGroup as={Col} md={10}>
				<AccordionForm
					defaultShow={nonPurchaseCategoryConfig != null}
					eventKey={key}
					title={highlight非(adCopyStrategyTargetGroupLabels[key])}
				>
					<>
						<Row>
							<Col md={4}>
								<AdCopyRadios
									checked={nonPurchaseCategoryConfig?.categoryOrAnd ?? ""}
									choices={[
										{
											label: "設定しない",
											value: "",
										},
										...adCopyOrAndOptions,
									]}
									name={`${key}_categoryOrAnd`}
									onChange={(value) => {
										onChange(
											key,
											value === ""
												? undefined
												: {
														...nonPurchaseCategoryConfig,
														categoryOrAnd: value as "And" | "Or",
														surveyChoices: nonPurchaseCategoryConfig?.surveyChoices ?? [],
												  },
										);
									}}
								/>
							</Col>
						</Row>

						{nonPurchaseCategoryConfig?.categoryOrAnd && (
							<Row>
								<Col md={3} style={{ marginBottom: "0.6em" }} />

								<Col md={12}>
									<AdCopyCheckboxes
										checkeds={nonPurchaseCategoryConfig.surveyChoices.map((c) => c.value)}
										choices={surveyChoiceOptions}
										disabledChoices={strategyGroup.category?.map((x) => x.surveyChoice)}
										name={`${key}_surveyChoices`}
										onChange={(nextValues) => {
											onChange(key, {
												...nonPurchaseCategoryConfig,
												surveyChoices: surveyChoiceOptions.filter((x) => nextValues.includes(x.value)),
											});
										}}
									/>

									{categoryOrAndError && (
										<Feedback style={{ display: "block" }} type="invalid">
											{categoryOrAndError}
										</Feedback>
									)}
								</Col>
							</Row>
						)}
					</>
				</AccordionForm>
			</FormGroup>
		</Row>
	);
});
